import React from "react";
import {SUPPORTED_LANGUAGES} from "./Translation";
import {THEMES} from "./Theme";
import useTheme from "../useHooks/useTheme";

export const ThemeSelect = () => {

    const {currentTheme, setTheme} = useTheme();

    if( ! THEMES || Object.keys(THEMES ).length === 1 )
        return;

    const onUpdate = value => {
        setTheme( value.target.value );
    }

    return <div className={"languageSelect"}>
        <select name="theme" id="theme-select" onChange={onUpdate} value={currentTheme}>
            { Object.keys( THEMES )
                .filter( theme => theme !== 'default' )
                .map( theme =>
                <option key={ THEMES[theme] } value={ THEMES[theme] }>{ THEMES[theme] }</option>)
            }
        </select>
    </div>
}